import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { deliverDemand } from '@/api/demand/demand';

export default {
  props: {
    deliverGroupList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    demandId: {
      type: [Number, String],
      required: true
    },

    validate: {
      type: Function,
      required: true
    },

    saveAppInfo: {
      type: Function,
      required: true
    },

    demand: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      submitButton: {
        type: 'primary',
        loading: false
      }
    };
  },


  methods: {
    submit: function submit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var valid;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.validate();

              case 2:
                valid = _context.sent;

                if (valid === true) {
                  _this.saveAppInfo(function () {
                    return _this.deliver();
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    deliver: function deliver() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.submitButton.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return deliverDemand({
                  id: _this2.demandId,
                  creations: _this2.cookCreations(),
                  meta_pl: _this2.demand.meta_pl,
                  meta_cl: _this2.demand.meta_cl,
                  meta_tc: _this2.demand.meta_tc
                });

              case 4:
                _this2.$message.success('交付需求成功');
                setTimeout(function () {
                  _this2.back();
                }, 1000);
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);
                _this2.submitButton.loading = false;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    cookCreations: function cookCreations() {
      return _.flatten(this.deliverGroupList).map(function (deliver) {
        var newDeliver = {
          channel_id: deliver.channel,
          attachment_url: deliver.path,
          name: deliver.name
        };
        if (deliver.id) {
          newDeliver.id = deliver.id;
        }
        if (deliver.material_tag_ids) {
          newDeliver.material_tag_ids = deliver.material_tag_ids;
        }
        if (deliver.scene_num) {
          newDeliver.scene_num = Number(deliver.scene_num);
        }
        return newDeliver;
      });
    },
    back: function back() {
      window.history.back();
    }
  }
};